export default __webpack_public_path__ + "static/media/31.31619d49.jpg";